<script setup lang="ts">
import { UIModal, UIProgress } from '@gohighlevel/ghl-ui'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { PaymentRedirect } from '../../../assets'

const props = defineProps({
  redirectModal: Boolean,
  secondsTillRedirectToPayment: Number,
  maxSecondsTillRedirectToPayment: Number,
  title: String,
  description: String,
})

const incrementalProgress = ref(1)
let intervalId: ReturnType<typeof setInterval> | null = null

onMounted(() => {
  intervalId = setInterval(() => {
    const maxAllowedProgress = props.maxSecondsTillRedirectToPayment
      ? 100 - props.maxSecondsTillRedirectToPayment
      : 100

    if (
      incrementalProgress.value < 100 &&
      incrementalProgress.value < maxAllowedProgress
    ) {
      incrementalProgress.value += 1
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId)
  }
})

const progress = computed(() => {
  if (
    props.secondsTillRedirectToPayment &&
    props.maxSecondsTillRedirectToPayment
  ) {
    // Check if both props are equal
    if (
      props.secondsTillRedirectToPayment ===
      props.maxSecondsTillRedirectToPayment
    ) {
      // Use incremental progress (1 per second) but don't exceed the max allowed
      const maxAllowedProgress = 100 - props.maxSecondsTillRedirectToPayment
      return Math.min(incrementalProgress.value, maxAllowedProgress)
    } else {
      // Use the 100 - secondsTillRedirectToPayment logic
      return 100 - props.secondsTillRedirectToPayment
    }
  }
  return incrementalProgress.value
})
</script>

<template>
  <UIModal :show="redirectModal">
    <div class="flex items-center w-full">
      <PaymentRedirect class="w-16 h-16 object-contain m-2 p-2" alt="" />
      <div class="pl-6 w-full">
        <p class="text-sm font-bold">
          {{ title }}
        </p>
        <UIProgress
          :percentage="progress"
          type="line"
          indicatorPlacement="outside"
          :processing="true"
          :circleGap="1"
          :gapDegree="75"
          :gapOffsetDegree="0"
          :offsetDegree="0"
          :strokeWidth="7"
          unit="%"
        />
        <p class="text-sm">
          {{ description }}
        </p>
      </div>
    </div>
  </UIModal>
</template>

<style>
.n-card__content {
  padding-top: 0 !important;
}
</style>
